"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var grid_1 = require("@rebass/grid");
var styled_components_1 = __importDefault(require("styled-components"));
exports.TileWrapper = styled_components_1["default"](grid_1.Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    overflow: hidden;\n    height: 50vh;\n    cursor: pointer;\n\n    ", "\n\n"], ["\n    position: relative;\n    overflow: hidden;\n    height: 50vh;\n    cursor: pointer;\n\n    ",
    "\n\n"])), function (props) { return !props.noPseudoElement ? "\n    &:after {\n        display: block;\n        position: relative;\n        background-image: linear-gradient(180deg,transparent 0,rgba(0,0,0,.6));\n        margin-top: -150px;\n        height: 150px;\n        width: 100%;\n        content: \"\";\n        z-index: 1;\n    }\n    " : ""; });
var templateObject_1;
